const toSlugs = (items: Array<Slug> | undefined) => (items?.length ? items.map(({ slug }) => slug) : undefined);

export const getCmsInfoForPage = (pageProps: Record<string, unknown> | undefined): CmsInfo => {
  if (!pageProps) {
    return {};
  }

  const { category, page, post, siteSlug, tag } = pageProps as CmsPageProps;

  let authorName: string | undefined;
  let categories: Array<Slug> | undefined;
  let pageIdentifiers: Array<Slug> | undefined;
  let postType: string | undefined;
  let tags: Array<Slug> | undefined;

  if (post) {
    authorName = post.author?.name;
    categories = post.categories;
    pageIdentifiers = post.pageIdentifiers;
    postType = post.type;
    tags = post.postTags;
  } else if (category) {
    categories = [{ slug: category.slug }];
  } else if (tag) {
    tags = [{ slug: tag.slug }];
  }

  if (page) {
    pageIdentifiers = page.pageIdentifiers;
    postType = page.type || 'page';
  }

  const categorySlugs = toSlugs(categories);
  const pageIdentifierSlugs = toSlugs(pageIdentifiers);
  const tagSlugs = toSlugs(tags);

  return {
    ...(categorySlugs && { taxonomy_categories_txt: categorySlugs }),
    ...(tagSlugs && { taxonomy_tags_txt: tagSlugs }),
    ...(pageIdentifierSlugs && { taxonomy_page_identifier_txt: pageIdentifierSlugs }),
    ...(postType && { post_type: postType }),
    ...(authorName && { author_name: authorName }),
    ...(siteSlug && { site_slug: siteSlug }),
  };
};

type Slug = { slug: string };

type CmsEntry = {
  author?: { name?: string };
  categories?: Array<Slug>;
  pageIdentifiers?: Array<Slug>;
  postTags?: Array<Slug>;
  type?: string;
};

type CmsPageProps = {
  category?: Slug;
  page?: CmsEntry;
  post?: CmsEntry;
  siteSlug?: string;
  tag?: Slug;
};

export type CmsInfo = {
  author_name?: string;
  post_type?: string;
  site_slug?: string;
  taxonomy_categories_txt?: Array<string>;
  taxonomy_page_identifier_txt?: Array<string>;
  taxonomy_tags_txt?: Array<string>;
};
